<td
  class="calendar-minute-column"
  style="border-right: 0"
  ion-text-center
  [hidden]="timeslot.get('hideLabels') || !timeslot.get('showLeftMinuteLabels')"
  [ngClass]="{ 'sm-day-view-tm-ishour': timeslot.get('minutes') == 0 }"
>
  {{ timeslot.get("minutes") == 0 ? "00" : timeslot.get("minutes") }}
</td>

<td
  class="calendar-hour-column ion-text-center"
  rowspan="4"
  *ngIf="tableRowIndex % 4 == 0"
  [hidden]="timeslot.get('hideLabels')"
>
  <span class="calendar-hour">{{
    timeslot.get("hour") == 12 ? 12 : timeslot.get("hour") % 12
  }}</span>
  <br />
  <span class="calendar-am-pm">{{
    timeslot.get("hour") < 12 ? "am" : "pm"
  }}</span>
</td>

<td
  class="calendar-minute-column ion-text-center"
  [ngClass]="{ 'sm-day-view-tm-ishour': timeslot.get('minutes') == 0 }"
  [hidden]="timeslot.get('hideLabels')"
>
  {{ timeslot.get("minutes") == 0 ? "00" : timeslot.get("minutes") }}
</td>
<td
  class="calendar-cell"
  [ngClass]="{
    'sm-day-view-tm-unavailable': !timeslot.get('isAvailable'),
    'sm-day-view-tm-ishour': timeslot.get('minutes') == 0,
    'calendar-cell-selected': isCellSelected
  }"
  (click)="onTimeSlotSelected()"
  tappable
>
  <div
    [ngClass]="{
      'calendar-event-wrap': timeslot.get('events'),
      'sm-mute-click': timeslot.muteEventTappability
    }"
    *ngIf="timeslot.get('events')"
  >
    <div
      *ngFor="
        let displayEvent of timeslot.get('events');
        let displayEventIndex = index
      "
      [ngClass]="['calendar-event', displayEvent.cssClass]"
      (click)="onEventSelected($event, displayEvent)"
      tappable
      [ngStyle]="{
        top: 20 * (displayEvent.startOffsetMinutes / 15) + 'px',
        left:
          'calc(' +
          (100 / displayEvent.laneCount) * displayEvent.laneIndex +
          '% - ' +
          (10 / displayEvent.laneCount) * displayEvent.laneIndex +
          'px)',
        width:
          'calc(' +
          100 / displayEvent.laneCount +
          '% - ' +
          10 / displayEvent.laneCount +
          'px)',
        height: 20 * (eventDuration(displayEvent) / 15) - 1 + 'px'
      }"
    >
      <div class="calendar-event-inner">
        <div
          class="sm-calendar-dayview-calevent-icons"
          [ngClass]="
            displayEvent.part == 2 ? 'sm-calendar-dayview-calevent-part2' : ''
          "
        >
          <ion-icon
            [hidden]="
              !displayEvent.booking.isRecurring() || displayEvent.part == 2
            "
            name="repeat"
          >
          </ion-icon>
          <ion-icon
            [hidden]="
              displayEvent.service.getType() != 'service' ||
              !displayEvent.booking.client ||
              (!displayEvent.service.hasClientNotes() &&
                !displayEvent.service.hasStylistNotes()) ||
              displayEvent.part == 2
            "
            name="document"
          >
          </ion-icon>

          <ion-icon
            *ngIf="displayEvent.service.isBookBack() && displayEvent.part == 1"
            name="caret-down"
          >
          </ion-icon>

          <ion-icon
            *ngIf="displayEvent.service.isBookBack() && displayEvent.part == 2"
            name="caret-up"
          >
          </ion-icon>
        </div>
        <span class="sm-calendar-dayview-calevent-clientname">{{
          displayEvent.title
        }}</span>
        <br />
        <span>{{ displayEvent.content }}</span>
      </div>
    </div>
  </div>
</td>
